import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Nav, Navbar, NavDropdown, Image } from 'react-bootstrap';
import * as Cookies from "es-cookie";

import gql from "graphql-tag";
import { graphql } from "react-apollo";

import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo'
import { withRouter } from "react-router-dom";
import parse, { domToReact } from 'html-react-parser';
import Notification from '../components/navbars/Notification';
import BrandLogo from "../components/navbars/BrandLogo";
import '../components/navbars/_navbars.scss';




import { STUDENT_GLOBALS } from "../../utils/studentGlobals";
import CommonHeader from '../components/navbars/CommonHeader';
class CustomInstructions extends Component {
    backPathFunction() {
        let pathname = "";
        if ((this.props.history.location.state || {}).etype == "custom") {
            //pathname = "/student/exams/custom-exam";
            pathname = "/student/exams";
        }
        else if ((this.props.history.location.state || {}).etype == "error") {
            // pathname = "/student/exams/error-exam";
            pathname = "/student/exams";
        }
        else if ((this.props.history.location.state || {}).etype == "previous") {
            // pathname = "/student/exams/previous-paper-exam";
            pathname = "/student/exams";
        }
        else if ((this.props.history.location.state || {}).etype == "adaptive") {
            // pathname = "/student/exams/adaptive-exam";
            pathname = "/student/exams";
        }
        else if ((this.props.history.location.state || {}).etype == "schedule") {
            // pathname = "/student/exams/schedule-exam";
            pathname = "/student/exams";
        }
        else if ((this.props.history.location.state || {}).etype == "customchapter") {
            // pathname = "/student/get-ready-for-exam/chapter-exam";
            pathname = "/student/get-ready-for-exam";
        }
        else if ((this.props.history.location.state || {}).etype == "customcumulative") {
            // pathname = "/student/get-ready-for-exam/cumulative-exam";
            pathname = "/student/get-ready-for-exam";
        }
        else if ((this.props.history.location.state || {}).etype == "customgrand") {
            // pathname = "/student/get-ready-for-exam/grand-exam";
            pathname = "/student/get-ready-for-exam";
        }
        else if ((this.props.history.location.state || {}).etype == "customsemi") {
            // pathname = "/student/get-ready-for-exam/semigrand-exam";
            pathname = "/student/get-ready-for-exam";
        }
        else if ((this.props.history.location.state || {}).etype == "customgetready") {
            pathname = "/student/get-ready-for-exam";
        }
        else if ((this.props.history.location.state || {}).etype == "schedulehome") {
            pathname = "/student/home";
        }
        return pathname;

    }
    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        console.log("CustomInstructions", this.props.history.location.state);
        const studentGlobals = this.props.studentGlobals;
        const loading5 = studentGlobals.loading;
        const error5 = studentGlobals.error;



        if (loading5) return <PreloaderTwo />;

        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }


        const instructions = studentGlobals.studentGlobals.examInstructions.find((a) => a.is_exam == "1");

        return (
            <div className="CustomInstructions header-top">
                <CommonHeader color="auto" tone="light" back={true} left={<BrandLogo width="159.501" fill="#ffffff" />} />
                <div className="bg-success py-3">
                    <Container fluid className="d-flex justify-content-between align-items-center">

                        {(this.props.history.location.state || {}).etype == "customtable" ? (
                            <Link
                                to={{
                                    pathname: "/student/get-ready-for-exam/history",
                                    state: {
                                        getReadyForExamList: (this.props.history.location.state || {}).getReadyForExamList
                                    }
                                }}
                                className="my-0 font-weight-normal text-light"><i className="fal fa-arrow-left" /> Back</Link>)
                            : (this.props.history.location.state || {}).etype == "examanalysis" ? (
                                <Link
                                    to={{
                                        pathname: "/student/practice-exam-analysis"
                                    }}
                                    className="my-0 font-weight-normal text-light"><i className="fal fa-arrow-left" /> Back</Link>) : (
                                    <Link to={this.backPathFunction()} className="my-0 font-weight-normal text-light">
                                        <i className="fal fa-arrow-left" />
                                        Back
                                </Link>
                                )}
                        <div className="my-2 my-md-0 text-center">
                            <h6 className="title mb-0 mr-4 text-white">Instruction</h6>
                        </div>
                        <div>&nbsp;</div>
                    </Container>
                </div>
                <div className="content-box mt-5" style={{ height: '100vh' }}>
                    <Container fluid>
                        <Row>
                            <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>

                                <h6 className="mb-2"><u>Please read the following instructions carefully.</u></h6>
                                {parse(instructions.instructions)}
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="bg-white py-3 border-top shadow-sm">
                    <Container>
                        <Row><Col xl={12} lg={12} md={12} className="text-right">

                            {(this.props.history.location.state || {}).etype == "custom"
                                || (this.props.history.location.state || {}).etype == "error"
                                || (this.props.history.location.state || {}).etype == "previous"
                                || (this.props.history.location.state || {}).etype == "adaptive"
                                || (this.props.history.location.state || {}).etype == "customchapter"
                                || (this.props.history.location.state || {}).etype == "customcumulative"
                                || (this.props.history.location.state || {}).etype == "customgrand"
                                || (this.props.history.location.state || {}).etype == "customsemi"
                                || (this.props.history.location.state || {}).etype == "customtable"
                                || (this.props.history.location.state || {}).etype == "customgetready" ? (

                                    <Link
                                        to={{
                                            pathname: "/student/subject/exam",
                                            state: {
                                                sessionid: (this.props.history.location.state || {}).sessionid,
                                                type: (this.props.history.location.state || {}).type,
                                                stype: "",
                                                exam_paper_id: "0",
                                                etype: (this.props.history.location.state || {}).etype

                                            }
                                        }}
                                        className="btn btn-outline-primary px-5"
                                    >
                                        Start Exam
                            </Link>) : ((this.props.history.location.state || {}).etype == "schedulehome" || (this.props.history.location.state || {}).etype == "schedule") ? (
                                    <Link
                                        to={{
                                            pathname: "/student/subject/exam",
                                            state: {
                                                sessionid: "0",
                                                type: (this.props.history.location.state || {}).type,
                                                stype: "schedule_exam",
                                                exam_paper_id: (this.props.history.location.state || {}).sessionid.toString(),
                                                etype: (this.props.history.location.state || {}).etype
                                            }
                                        }}
                                        className="btn btn-outline-primary px-5"
                                    >
                                        Start Exam
                            </Link>) : ("")}

                        </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        )
    }
}


export default withRouter(compose(
    graphql(STUDENT_GLOBALS,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                },
                // Shared studentGlobals union; see utils/studentGlobals.
                fetchPolicy: "cache-first"
            }), name: "studentGlobals"
        }))(CustomInstructions));
